import React from 'react';

const SortField = ({ className, name, label, sort, handlers }) => (
  <th className={`${className}`} onClick={handlers.onSortChange(name)}>
    <span>{label}{(sort.name === name) && <b className={`${sort.asc ? 'caret-down' : 'caret-up'}`}/>}</span>
  </th>
);

export default SortField;
